import { SSRPermissionsErrorHandler } from '../src/SSRPermissionsErrorHandler';

export const ssrPermissionsErrorHandler = new SSRPermissionsErrorHandler();
